export default "__VITE_ASSET__DMMdrDt$__"